import {
  GET_DOCUMENT_TYPE_TURN_DOWNLOAD_FAILURE,
  GET_DOCUMENT_TYPE_TURN_DOWNLOAD_REQUEST,
  GET_DOCUMENT_TYPE_TURN_DOWNLOAD_SUCCESS,
  GET_DOCUMENT_TYPE_TURN_FAILURE,
  GET_DOCUMENT_TYPE_TURN_REQUEST,
  GET_DOCUMENT_TYPE_TURN_SUCCESS,
} from "./document-typeTurnTypes";

const initialState = {
  loading: false,
  types: [],
  error: "",
};

const getDocumenTypeTurnReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENT_TYPE_TURN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DOCUMENT_TYPE_TURN_SUCCESS:
      return {
        loading: false,
        types: action.payload,
        error: "",
      };
    case GET_DOCUMENT_TYPE_TURN_FAILURE:
      return {
        loading: false,
        types: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateDownload = {
  loading: false,
  types: [],
  error: "",
};

const getDocumenTypeTurnDownloadReducer = (state = initialStateDownload, action) => {
  switch (action.type) {
    case GET_DOCUMENT_TYPE_TURN_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DOCUMENT_TYPE_TURN_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        types: action.payload,
        error: "",
      };
    case GET_DOCUMENT_TYPE_TURN_DOWNLOAD_FAILURE:
      return {
        loading: false,
        types: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getDocumenTypeTurnReducer,getDocumenTypeTurnDownloadReducer};
